import { useDispatch } from 'react-redux';
import { downloadProductPdf, printProductPdf } from '@client/product/redux/productPdf/redux';

export type UseProductPdfActionsReturnType = {
  printPdf: (sku: string, content: string) => void;
  downloadPdf: (sku: string, content: string) => void;
};

export const useProductPdfActions = (): UseProductPdfActionsReturnType => {
  const dispatch = useDispatch();

  return {
    printPdf: (sku: string, content: string) => {
      dispatch(printProductPdf({ sku, content }));
    },
    downloadPdf: (sku: string, content: string) => {
      dispatch(downloadProductPdf({ sku, content }));
    },
  };
};
